<template>
  <div>
    <v-row class="pt-5" justify="center">
      <img class="my-2" src="@/assets/cardImages/visa.svg" height="26px" />
      <img
        class="my-2"
        src="@/assets/cardImages/mastercard.svg"
        height="26px"
      />
      <img
        class="my-2"
        src="@/assets/cardImages/discovercard.svg"
        height="26px"
      />
      <img
        class="my-2"
        src="@/assets/cardImages/americanexpress.svg"
        height="26px"
      />
    </v-row>
    <v-card max-width="500px" min-width="300px" class="mt-5" outlined>
      <v-card-text>
        <div class="payment-simple">
          <StripeElements
            :stripe-key="stripeKey"
            :instance-options="instanceOptions"
            :elements-options="elementsOptions"
            ref="elms"
            #default="{ elements }"
          >
            <StripeElement
              type="card"
              :elements="elements"
              :options="cardOptions"
              ref="card"
            />
          </StripeElements>
          <!-- <button @click="pay" type="button">Pay</button> -->
        </div>
        <!-- <card
                      class="stripe-card my-3"
                      :class="{ complete }"
                      :stripe="stripePublicKey"
                      @change="complete = $event.complete"
                    /> -->
        <img
          class="my-2 mt-5"
          src="@/assets/cardImages/powered_by_stripe.svg"
          height="26px"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { StripeElements, StripeElement } from "vue-stripe-elements-plus";
import EventBus from '@/event-bus';

export default {
  name: "collect-creditcard",
  data() {
    return {
      stripeKey: process.env.VUE_APP_STRIPE_PK, // test key, don't hardcode
      instanceOptions: {
        // https://stripe.com/docs/js/initializing#init_stripe_js-options
      },
      elementsOptions: {
        // https://stripe.com/docs/js/elements_object/create#stripe_elements-options
      },
      cardOptions: {
        // reactive
        // remember about Vue 2 reactivity limitations when dealing with options
        value: {
          postalCode: "",
        },
        // https://stripe.com/docs/stripe.js#element-options
      },
    };
  },
  components: {
    StripeElements,
    StripeElement,
  },
  beforeDestroy() {
    EventBus.$off('get-card');
  },
  mounted() {
    // console.log('process.env', process.env)
    EventBus.$on('get-card', async () => {
      const token = await this.getCard()
      this.$emit('token', token)
    })
  },  
  methods: {
    async getCard() {
      
      // ref in template
      // console.log("pay press");
      const groupComponent = this.$refs.elms;
      const cardComponent = this.$refs.card;
      // Get stripe element
      const cardElement = cardComponent.stripeElement;
      // console.log("pay press", groupComponent, cardComponent, cardElement);

      // Access instance methods, e.g. createToken()
      const token = await groupComponent.instance.createToken(cardElement);
      // console.log("token", token);
      // if (token && token.error) {
      //   this.$toast.error(token.error, {
      //     timeout: 2000,
      //   });
      // }
      
      return token;
      
    },
  },
};
</script>

<style scoped>
</style>